import React from "react";
import Terminal from "./components/Terminal";

const App = () => <Terminal />;

export default App;